import { render, staticRenderFns } from "./GestionTiposUnidades.vue?vue&type=template&id=e09d2ef8&scoped=true"
import script from "./GestionTiposUnidades.vue?vue&type=script&lang=js"
export * from "./GestionTiposUnidades.vue?vue&type=script&lang=js"
import style0 from "./GestionTiposUnidades.vue?vue&type=style&index=0&id=e09d2ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09d2ef8",
  null
  
)

export default component.exports